import React from 'react';

const JsolMain = () => {
  return <div></div>;
};

export default JsolMain;
